import {gql} from '@apollo/client'


//Zapis odpowiedzi
const ZAP_Odpowiedz = gql`
mutation odpowiedz($id_uczestnika:Int!,$id_konkursu:Int!,$id_pytania:Int!,$id_odpowiedzi:String!){
    odpowiedz(id_uczestnika:$id_uczestnika,id_konkursu:$id_konkursu,id_pytania:$id_pytania,id_odpowiedzi:$id_odpowiedzi){
    id
    }
}
`
const Logowanie = gql`
mutation Login($login:String!,$haslo:String!) {
    logowanie(login:$login,haslo:$haslo) {
        token
        imie
        nazwisko
        id
    }
}
`
const AutoryzacjaKonkurs = gql`
mutation Login($dane:KontrolaKonkurs!) {
    autoryzacjaKonkurs(dane:$dane) {
        token
        imie
        nazwisko
        id
    }
}
`

export {ZAP_Odpowiedz,Logowanie, AutoryzacjaKonkurs}